import {ReportRow} from '../ReportTypes';
import {getSavedReportURLByReportType} from '../../../../components/insights/saved_report_util';
import {UseHistoryType} from '../ReportsPage';

export const openReport = (report: ReportRow, history: UseHistoryType): void => {
	const path = getSavedReportURLByReportType(report.type, report.id);
	history.push(path);
};
